angular.module('mercury.modules.stock', [
  'mercury.modules.stock.brand',
  'mercury.modules.stock.item',
  'mercury.modules.stock.menu',
  'mercury.modules.stock.positemlink',
  'mercury.modules.stock.purchaseorder',
  'mercury.modules.stock.recipe',
  'mercury.modules.stock.report',
  'mercury.modules.stock.statement',
  'mercury.modules.stock.stockonhandreport',
  'mercury.modules.stock.stockorder',
  'mercury.modules.stock.stockordertemplate',
  'mercury.modules.stock.stocktake',
  'mercury.modules.stock.stocktakereport',
  'mercury.modules.stock.stocktaketemplate',
  'mercury.modules.stock.supplier',
  'mercury.modules.stock.tender',
  'mercury.modules.stock.unit',
  'mercury.modules.stock.deliverydetail',
  'mercury.modules.stock.xero',
  'mercury.modules.stock.invoices',
  'mercury.modules.stock.stockreceived',
  'mercury.modules.stock.stockcost',
  'mercury.modules.stock.predictedorder'
]);
